import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { URL_PATHS_MAP } from '../../app.routes';
import { MatIconModule } from '@angular/material/icon';
import { OtpVerificationService } from '../../core/services/otp-verification/otp-verification.service';
import { HttpStatusCode } from 'axios';
import { SnackbarService } from '../../shared/services/snackbar/snackbar.service';
import { SessionStorageService } from '../../core/services/session-storage/session-storage.service';
import { CurrentUserInfo } from '../../core/interfaces/current-user-info.interface';
import { SessionTokens } from '../../core/enums/session-tokens.enum';

@Component({
  selector: 'app-otp-verification',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    RouterModule,
    MatIconModule
  ],
  templateUrl: './otp-verification.page.html',
  styleUrl: './otp-verification.page.scss',
  providers: [DatePipe]
})
export class OtpVerificationPage implements OnInit {

  private formBuilder = inject(FormBuilder);
  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private otpVerificationService = inject(OtpVerificationService);
  private snackBarService = inject(SnackbarService);

  otpVerifyFg!: FormGroup;

  protected returnTo!: string | null;

  protected isVerifyOtpLoading = signal(false);

  protected otpRequestCountDown: number = (3 * 60000); // 3 minutes in milliseconds
  protected otpCountDown: number = 0;
  protected isOtpTimerEnabled = signal(false);
  protected otpResendClickCount: number = 0;
  protected otpInterval!: number;

  constructor() { }

  ngOnInit(): void {
    this.otpVerifyFg = this.formBuilder.group({
      otpCode: ["", [Validators.required]]
    });

    const isOtpAllowed = sessionStorage.getItem(SessionTokens.IS_OTP_ALLOWED);

    if (!isOtpAllowed) {
      this.router.navigate(['/login']);
      return;
    }

    // remove flag
    sessionStorage.removeItem(SessionTokens.IS_OTP_ALLOWED);

    const URL_TOKEN = history.state.returnPath.toString();

    this.returnTo = URL_PATHS_MAP[URL_TOKEN] ?? '/';

    if (!this.returnTo) {
      console.error('Return URL is not provided.');
    }



    this.setOtpTimer();
  }

  protected async requestOtpEmail() {
    // const responseData = await this.otpVerificationService
    //   .resendOtp()
    //   .then((response) => {
    //     return JSON.parse(response);
    //   })
    //   .catch((error) => {
    //     // console.error(error);
    //     return error;
    //   });

    // if (responseData.status === HttpStatusCode.Ok) {
    //     const currentUserInfo: CurrentUserInfo = {
    //       email: this.sessionStorageService.getCurrentUserEmail(),
    //       accessToken: responseData.data.accesstoken,
    //       password: this.sessionStorageService.getCurrentUserPassword()
    //     };

    //     this.sessionStorageService.setCurrentUserInfo(currentUserInfo);
    // } else {
    //   if (responseData.code === HttpStatusCode.BadRequest) {
    //     // Display notification on API failure.
    //     this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
    //   }
    // }

    if (this.otpResendClickCount == 5) {
      this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      return;
    } else {
      this.otpResendClickCount = this.otpResendClickCount + 1;
    }

    const responseData = await this.otpVerificationService
      .requestOtp()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar("Processed your request successfully.");
      this.setOtpTimer();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
    }
  }

  protected setOtpTimer() {
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
    }

    this.isOtpTimerEnabled.set(true);

    this.otpCountDown = this.otpRequestCountDown;

    this.otpInterval = window.setInterval(() => {
      if (this.otpCountDown != 0) {
        this.otpCountDown = this.otpCountDown - 1000;
      } else {
        this.isOtpTimerEnabled.set(false);
        clearInterval(this.otpInterval);
        this.otpInterval = NaN;
      }
    }, 1000);

  }

  protected async otpVerification() {
    const otpCode: string = this.otpVerifyFg.get('otpCode')?.value.toString();

    this.isVerifyOtpLoading.set(true);

    const responseData = await this.otpVerificationService
      .otpVerification(otpCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.isVerifyOtpLoading.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      const currentUserInfo: CurrentUserInfo = {
        repCode: this.sessionStorageService.getCurrentRepCode(),
        userId: this.sessionStorageService.getCurrentUserId(),
        email: this.sessionStorageService.getCurrentUserEmail(),
        authToken: responseData.data.token,
        userName:this.sessionStorageService.getCurrentUserName(),
        personName: this.sessionStorageService.getCurrentUserPersonName(),
        userRole: this.sessionStorageService.getCurrentUserRole(),
        // accessToken: responseData.data.accesstoken,
        userGroup: this.sessionStorageService.getCurrentUserGroup(),
        userModel:this.sessionStorageService.getCurrentUserModel(),
        applicantStatus: this.sessionStorageService.getCurrentApplicantStatus(),
        adflag: this.sessionStorageService.getCurrentAdflag()
      };

      this.sessionStorageService.setCurrentUserInfo(currentUserInfo);
      this.router.navigate([this.returnTo]);
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("Invalid OTP");
      }
    }
  }

}
